<template>
    <v-container>
        <v-layout text-center wrap >
            <v-row no-gutters>
                <v-col cols="12">
                  <v-card flat>
                  <v-card-text>
                    <v-tabs background-color="white" color="deep-purple accent-4" left>
                        <v-tab>All Payments</v-tab>
                        <v-tab>Unpaid Payments</v-tab>
                        <v-tab>Processed Payments</v-tab>
                        <v-tab-item >
                          <v-container fluid>
                            <v-row>
                              <v-col cols="12">
                                <all-payments-data-table />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-tab-item>

                        <v-tab-item >
                          <v-container fluid>
                            <v-row no-gutters>  
                                Uppaid Payments
                            </v-row>
                          </v-container>
                        </v-tab-item>

                        <v-tab-item >
                          <v-container fluid>
                            <v-row>
                              <v-col cols="12" md="4">
                                Processed Payments
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-tab-item>
                    </v-tabs>
                  </v-card-text>
                </v-card>
                </v-col>
            </v-row>
        </v-layout>
    </v-container>
</template>

<script>

import AllPaymentsDataTable from '@/components/AllPaymentsDataTable';

export default {
    name: 'PaymentsCharges',
    data: () => ({
      date: new Date().toISOString().substr(0, 10)
    }),
    components: {
      AllPaymentsDataTable
    }
};
</script>
